export const ceilToNearest = (number: number) => {
  if (number <= 0) return 0;
  if (number < 10) return 10;
  const orderOfMagnitude = 10 ** Math.floor(Math.log10(number));
  return Math.ceil(number / orderOfMagnitude) * orderOfMagnitude;
};
